export const APP_VERSION = '2.16.1';

import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { LangProvider } from './context/LangContext';
import { BackgroundJobsProvider } from './context/BackgroundJobsContext';
import Layout from './components/Layout';
import StagingBanner from './components/StagingBanner';
import LoginPage       from './pages/LoginPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import Dashboard       from './pages/Dashboard';
import AuditListPage   from './pages/AuditListPage';
import AuditDetailPage from './pages/AuditDetailPage';
import FindingPage     from './pages/FindingPage';
import ClientsPage     from './pages/ClientsPage';
import UsersPage          from './pages/UsersPage';
import ClientDetailPage  from './pages/ClientDetailPage';
import TemplatesPage    from './pages/TemplatesPage';
import ReportsPage      from './pages/ReportsPage';
import MailPage         from './pages/MailPage';
import FrameworksPage   from './pages/FrameworksPage';
import BackgroundJobsPage from './pages/BackgroundJobsPage';
import AccountPage      from './pages/AccountPage';
import PortalReportPage from './pages/portal/PortalReportPage';
import PortalHomePage   from './pages/portal/PortalHomePage';

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user)   return <Navigate to="/login" replace />;
  return <Layout>{children}</Layout>;
}

function AppRoutes() {
  const { user, loading } = useAuth();
  if (loading) return null;

  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/" replace /> : <LoginPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />

      {/* Publiek klantenportaal (geen hoofd-app-login) */}
      <Route path="/portal" element={<PortalHomePage />} />
      <Route path="/portal/r/:token" element={<PortalReportPage />} />
      <Route path="/portal/report/:shareId" element={<PortalReportPage />} />
      <Route path="/" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/audits" element={<ProtectedRoute><AuditListPage /></ProtectedRoute>} />
      <Route path="/audits/:id" element={<ProtectedRoute><AuditDetailPage /></ProtectedRoute>} />
      <Route path="/audits/:auditId/findings/:findingId" element={<ProtectedRoute><FindingPage /></ProtectedRoute>} />
      <Route path="/clients"    element={<ProtectedRoute><ClientsPage /></ProtectedRoute>} />
      <Route path="/clients/:id" element={<ProtectedRoute><ClientDetailPage /></ProtectedRoute>} />
      <Route path="/users"      element={<ProtectedRoute><UsersPage /></ProtectedRoute>} />
      <Route path="/templates"   element={<ProtectedRoute><TemplatesPage /></ProtectedRoute>} />
      <Route path="/reports"     element={<ProtectedRoute><ReportsPage /></ProtectedRoute>} />
      <Route path="/mail"        element={<ProtectedRoute><MailPage /></ProtectedRoute>} />
      <Route path="/frameworks"  element={<ProtectedRoute><FrameworksPage /></ProtectedRoute>} />
      <Route path="/background-jobs" element={<ProtectedRoute><BackgroundJobsPage /></ProtectedRoute>} />
      <Route path="/account" element={<ProtectedRoute><AccountPage /></ProtectedRoute>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <LangProvider>
        <AuthProvider>
          <BackgroundJobsProvider>
            <StagingBanner />
            <AppRoutes />
          </BackgroundJobsProvider>
        </AuthProvider>
      </LangProvider>
    </BrowserRouter>
  );
}
